<template>
  <v-row>
    <v-col cols="12" sm="6">
      <v-card outlined class="rounded-card" flat>
        <v-subheader class="font-weight-bold text--primary">
          E-mails
          <v-spacer />
          <px-fornecedor-adicionar-email :current-fornecedor="fornecedor" @update="onUpdate">
            <template v-slot:activator="{ on }">
              <v-btn v-if="hasRoleComprador"
                   small
                   color="primary"
                   class="normal-btn-text rounded-tag-small elevation-0"
                   v-on="on">
                <v-icon small>mdi-plus</v-icon>
                Email
              </v-btn>
            </template>
          </px-fornecedor-adicionar-email>
        </v-subheader>
        <v-divider />
        <px-lista-emails :has-role-comprador="hasRoleComprador"
                         :fornecedor="fornecedor"
                         @update="onUpdate"/>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6">
      <v-card outlined class="rounded-card" max-width="auto">
        <v-subheader class="font-weight-bold text--primary">
          Telefones
          <v-spacer/>
          <px-fornecedor-adicionar-whatsapp :current-fornecedor="fornecedor"
                                            :is-nacional="isNacional"
                                            @update="onUpdate">
            <template v-slot:activator="{ on }">
              <v-btn v-if="hasRoleComprador"
                     small
                     color="primary"
                     class="normal-btn-text rounded-tag-small elevation-0"
                     v-on="on">
                <v-icon small>mdi-plus</v-icon>
                  Telefone
              </v-btn>
            </template>
          </px-fornecedor-adicionar-whatsapp>
        </v-subheader>
        <v-divider />
        <px-lista-whatsapp :has-role-comprador="hasRoleComprador"
                           :fornecedor="fornecedor"
                           :is-nacional="isNacional"
                           @update="onUpdate"/>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { TipoFornecedor } from 'px-business-components';
import FornecedorAdicionarEmail from '../components/FornecedorAdicionarEmail.vue';
import FornecedorAdicionarWhatsapp from '../components/FornecedorAdicionarWhatsapp.vue';
import ListaEmails from '../components/listas/ListaEmails.vue';
import ListaWhatsapp from '../components/listas/ListaWhatsapp.vue';

export default {
  props: {
    fornecedor: Object,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    onUpdate() {
      this.$emit('update');
    },
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
    isNacional() {
      return this.fornecedor.fornecedor.tipo === TipoFornecedor.keys.NACIONAL.key
        || this.fornecedor.fornecedor.tipoFilho === TipoFornecedor.keys.PESSOA_FISICA.key;
    },
  },
  components: {
    pxFornecedorAdicionarEmail: FornecedorAdicionarEmail,
    pxFornecedorAdicionarWhatsapp: FornecedorAdicionarWhatsapp,
    pxListaEmails: ListaEmails,
    pxListaWhatsapp: ListaWhatsapp,
  },
};

</script>
